"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusMFAOptionsMockProps = void 0;
exports.statusMFAOptionsMockProps = {
    title: '',
    field: {
        name: 'mfa',
    },
    options: [
        { value: 'email', label: 'Email', id: 1 },
        { value: 'mobile', label: 'Mobile', id: 2 },
    ],
};
